import store from "../../redux/store";

function GetAvdelningById(avdid) {
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return null;
  return state.user.user.avdelnings.find((obj) => {
    return obj.id === avdid;
  });
}

store.subscribe(GetAvdelningById);

export default GetAvdelningById;
